import comp from "./SearchResultsV2";
export default comp;
